import { useTranslation } from "react-i18next";
import { Text } from "@foris/avocado-suite";
import Modal from "@components/modal";
import styles from "./assignmentViewDiscardModal.module.scss";

interface AssignmentViewDiscardModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}

const AssignmentViewDiscardModal = ({
  isOpen,
  onCancel,
  onDiscard,
}: AssignmentViewDiscardModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      className={styles.modal}
      typeState="warning"
      show={isOpen}
      title={t("assignation-edit.session-view.discard.title")}
      textButtonSecondary={t("generals.cancel")}
      colorButtonSecondary="ghost"
      textButtonPrincipal={t("assignation-edit.session-view.discard.confirm")}
      onClose={onCancel}
      onClickSecondary={onCancel}
      onClickPrincipal={onDiscard}
    >
      <Text>{t("assignation-edit.session-view.discard.description")}</Text>
    </Modal>
  );
};

export default AssignmentViewDiscardModal;
